import { Div } from '../../../base/components/native/div'
import { Img } from '../../../base/components/native/img'
import { ABSOLUTE, CENTER } from '../../../base/helpers/style'

export const StartAgainButton = () => {

    const base = Div()
    const title = Div('🪄 Not happy? Try again')
    base.append(title)

    base.cssClass({
        ...CENTER,
        color: '#fff',
        backgroundColor: '#000',
        height: '58px',
        padding: '0 28px',
        borderRadius: '10px',
        fontFamily: 'Roboto',
        fontWeight: '700',
        fontSize: '24px',
        cursor: 'pointer',
        marginTop: '40px',
        '&:hover': {
            opacity: '.9'
        },
        '@media (max-width: 520px)': {
            width: 'calc(100% - 20px)',
        }

    })

    return base
}